import { useRecordContext } from 'react-admin';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import { ActionColumnPropsType } from '../../../utils/DataTypes';

const ActionsColumn = ({ editRowIds, handleEdit, handleSave, handleCancel }: ActionColumnPropsType) => {
  const record = useRecordContext();
  if (!record) return null;

  const isEditing = editRowIds.includes(record.id.toString());

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      {!isEditing ? (
        <button
          onClick={() => handleEdit(record.id.toString())}
          style={{ border: 'none', background: 'none', cursor: 'pointer' }}
        >
          <EditIcon style={{ color: '#00909A' }} />
        </button>
      ) : (
        <>
          <button
            onClick={() => handleSave(record.id.toString())}
            style={{ border: 'none', background: 'none', cursor: 'pointer' }}
          >
            <SaveIcon style={{ color: '#00909A' }} />
          </button>
          <button
            onClick={() => handleCancel(record.id.toString())}
            style={{ border: 'none', background: 'none', cursor: 'pointer' }}
          >
            <CancelIcon style={{ color: 'gray' }} />
          </button>
        </>
      )}
    </div>
  );
};

export default ActionsColumn;
